export default {"src":"/_next/static/media/out.508d6cab.svg","height":512,"width":512};